<template>
  <div class=" bg-gray-900 ">
    <tw-container class="hidden lg:flex font-light py-2 px-4 md:px-8 gap-4 md:gap-6 justify-end text-white text-sm">
      <router-link :to="{name: 'ContactPage'}">
        Contact
      </router-link>
      <a href=""> Help </a>
      <router-link :to="{name: 'ContactPage'}">
        About
      </router-link>
    </tw-container>
  </div>
  <div class="flex flex-col gap-3 pt-3 md:pt-5 px-4 md:px-8">
    <tw-navbar-home-secondary ref="menu" :user="currentUser" />
    <!-- mobile search -->
    <home-search class="md:hidden" />
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import HomeSearch from '@/components/home/home-search.vue'

import TwContainer from './generic/tw-container.vue'
import TwNavbarHomeSecondary from './generic/navbar/tw-navbar-home-secondary.vue'


export default {
  name: "FrontPageTopNavigationSecondary",
  components: { TwNavbarHomeSecondary, TwContainer, HomeSearch },
  computed: {
    ...mapStores(useAuthStore),
    currentUser() {
      return useAuthStore().user
    },
  },
  methods: {

  },
}
</script>
